module.exports = __webpack_public_path__ + "static/media/cup_top_1.b221214c.webp";